import type { TFunction } from 'i18next';

import type { ShipmentStatus, UpdStatus } from '@/api/generated/model';

// Тексты статусов — в словарях (status.shipment.*, status.upd.*), формулировки ТЗ.
export const SHIPMENT_STATUS_COLOR: Record<ShipmentStatus, string> = {
  draft: 'default',
  at_warehouse: 'blue',
  shipped: 'geekblue',
  accepted_full: 'green',
  accepted_partial: 'orange',
  returned: 'red',
  cancelled: 'default',
};

export const UPD_STATUS_COLOR: Record<UpdStatus, string> = {
  uploaded: 'default',
  parsing: 'processing',
  needs_review: 'orange',
  draft_created: 'green',
  failed: 'red',
  rejected: 'default',
};

export type StatusKind = 'shipment' | 'upd';

/** Варианты для фильтра таблицы: [{ text, value }] на языке интерфейса. */
export function statusFilters<S extends string>(
  t: TFunction,
  kind: StatusKind,
  colors: Record<S, string>,
): { text: string; value: S }[] {
  return (Object.keys(colors) as S[]).map((value) => ({
    text: t(`status.${kind}.${value}.label`),
    value,
  }));
}
